import { Text } from '@skooldio/skooldio-ui-components-core';

export default Text;
